const config = {
  api: {
    portalLocal: 'http://10.0.0.97:3300',
    customer: 'https://th-test-customer-api.dimorder.com',
    dimorder: 'https://th-test-api.dimorder.com',
    node: 'https://th-test-node.dimorder.com',
  },
  env: 'test',
  keetaAppId: '3917793481',
  receipt: 'https://th-test-mp-order.dimorder.com/',
  report: 'https://th-test-report-api.dimorder.com/report/',
}

export default config
